









































import { Component, Ref } from 'vue-property-decorator';
import AdministratorsModule from '@/store/administrators';
import AdministratorEntityModule from '@/store/administrators/entity';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import Edit from '@/layouts/Edit';
import EditBlock from '@/views/CRUD/Edit.vue';
import FormView from './_form.vue';
import TitleReturn from '@/components/TitleReturn.vue';
import CPBtn from '@/components/buttons/CPBtn/CPBtn.vue';
import ConfirmModal from '@/components/modal/ConfirmModal.vue';

import UserModule, { RoleEnum } from '@/store/user';
import { Maybe } from '@/types/common';
import { AdministratorCard } from '@/types/models/administrators';
import { prepareAdministratorData, validateAdministratorForm } from '@/utils/administrators';
import { strings } from '@/lib/stringConst';
import { getApiErrorMessage } from '@/lib/Utils';

export type AdministratorErrors = Partial<Record<keyof AdministratorCard, string>>;

@Component({
    components: {
        Edit,
        EditBlock,
        FormView,
        TitleReturn,
        CPBtn,
        ConfirmModal,
    }
})
export default class AdministratorEditPage extends Edit {
    @Ref() $form!: FormView;

    titleEdit = '';
    errors: AdministratorErrors = {};
    profile: Maybe<AdministratorCard> = null;
    text = strings;
    isShowModal = false;

    get administratorId(): string {
        return this.$route.params.administratorsId;
    }

    get readonly() {
        return UserModule.role !== RoleEnum.ROLE_SUPER_ADMIN;
    }

    get isSuperAdmin() {
        return UserModule.isAdmin;
    }

    showModal() {
        this.isShowModal = true;
    }

    closeModal() {
        this.isShowModal = false;
    }

    returnToList() {
        this.$router.push({ name: 'administrators' });
    }

    triggerSave() {
        this.$form.triggerSave();
    }

    validate(administrator: AdministratorCard): boolean {
        this.errors = validateAdministratorForm(administrator);
        const errorsCount = Object.keys(this.errors).length

        return errorsCount === 0;
    }

    async activate() {
        if (!this.profile?.id) {
            return;
        }

        await AdministratorEntityModule.activate(String(this.profile.id));
        this.updateIsActive();
    }

    async deactivate() {
        if (!this.profile?.id) {
            return;
        }

        await AdministratorEntityModule.deactivate(String(this.profile.id));
        this.updateIsActive();
    }

    async updateIsActive() {
        if (!this.profile?.id) {
            return;
        }

        this.profile.is_active = await AdministratorEntityModule.getIsActive(String(this.profile.id)) ?? this.formValues.is_active;
    }

    async saveForm(administrator: AdministratorCard) {
        const isValid = this.validate(administrator);
        
        if (!isValid) {
            return;
        }

        this.errors = {};

        try {
            const data = prepareAdministratorData(administrator);
            await AdministratorEntityModule.update({
                id: this.administratorId,
                data,
            });

            ResponseHandlerModule.showNotify({ message: 'Информация об администраторе обновлена', type: 'ok' });
        } catch (error: any) {
            const errors = error?.response?.data?.errors?.fields;
            const errorFields: Record<string, string> = errors;

            const [errorMessage] = Object.values(errorFields);

            if (errorMessage) {
                this.errors = errorFields;
                ResponseHandlerModule.showNotify({ message: errorMessage, type: 'fail' });
            }
        }
    }

    async created() {
        this.titleEdit = AdministratorsModule.pageSettings.titleEdit;
        try {
            const profile = await AdministratorEntityModule.getById(this.administratorId);
            
            this.profile = profile;

        } catch (error: any) {
            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

            ResponseHandlerModule.cancelRedirectToNotFound();
            this.returnToList();
        }
    }

    async removeAdministrator() {
        try {
            await AdministratorEntityModule.remove(this.administratorId);
            this.returnToList();
        } catch (response) {
            ResponseHandlerModule.showNotify({ message: getApiErrorMessage(response), type: 'fail' });
        }
    }
}
